export const sliderConstants = {
  GETALL_REQUEST: 'SLIDERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'SLIDERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'SLIDERS_GETALL_FAILURE',

  GET_REQUEST: 'SLIDERS_GET_REQUEST',
  GET_SUCCESS: 'SLIDERS_GET_SUCCESS',
  GET_FAILURE: 'SLIDERS_GET_FAILURE',

  ADD_REQUEST: 'SLIDERS_ADD_REQUEST',
  ADD_SUCCESS: 'SLIDERS_ADD_SUCCESS',
  ADD_FAILURE: 'SLIDERS_ADD_FAILURE',

  UPDATE_REQUEST: 'SLIDERS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'SLIDERS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'SLIDERS_UPDATE_FAILURE',
}